<div class="app">
    @if (isLoading) {
        <div class="backdrop">
            <grainger-loading-spinner></grainger-loading-spinner>
        </div>
    }
    <router-outlet></router-outlet>
</div>
